import {
	FOLDER_FETCH_REQUEST,
	FOLDER_FETCH_FAILURE,
	FOLDER_FETCH_SUCCESS,
	FOLDER_DELETE_REQUEST,
	FOLDER_DELETE_FAILURE,
	FOLDER_DELETE_SUCCESS,
	FOLDER_UPDATE_REQUEST,
	FOLDER_UPDATE_FAILURE,
	FOLDER_UPDATE_SUCCESS,
	FOLDER_CREATE_REQUEST,
	FOLDER_CREATE_FAILURE,
	FOLDER_CREATE_SUCCESS,
	FOLDER_TOKEN_CREATE_REQUEST,
	FOLDER_TOKEN_CREATE_FAILURE,
	FOLDER_TOKEN_CREATE_SUCCESS,
	FOLDER_TOKEN_DELETE_REQUEST,
	FOLDER_TOKEN_DELETE_FAILURE,
	FOLDER_TOKEN_DELETE_SUCCESS,
	FILE_DELETE_REQUEST,
	FILE_DELETE_FAILURE,
	FILE_DELETE_SUCCESS,
	FILE_UPLOAD_REQUEST,
	FILE_UPLOAD_FAILURE,
	FILE_UPLOAD_SUCCESS,
	FOLDER_SET,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	isUpdating: false,
	isCreating: false,
	isDeleting: false,
	isDeletingFile: false,
	isUploadingFiles: false,
	isCreatingToken: false,
	isDeletingToken: false,
	message: {
		type: '',
		text: '',
	},
	selected: false,
};

export default function folders(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case FOLDER_SET:
			return {
				...state,
				selected: Number(payload.id),
			};

		case FOLDER_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
				selected: false,
			};

		case FOLDER_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
				selected: false,
			};

		case FOLDER_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: '',
					text: '',
				},
				selected: Number(payload.folder),
			};

		case FOLDER_UPDATE_REQUEST:
			return {
				...state,
				isUpdating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case FOLDER_UPDATE_FAILURE:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case FOLDER_UPDATE_SUCCESS:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case FOLDER_CREATE_REQUEST:
			return {
				...state,
				isCreating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case FOLDER_CREATE_FAILURE:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case FOLDER_CREATE_SUCCESS:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case FOLDER_DELETE_REQUEST:
			return {
				...state,
				isDeleting: true,
				message: {
					type: '',
					text: '',
				},
			};

		case FOLDER_DELETE_FAILURE:
			return {
				...state,
				isDeleting: true,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case FOLDER_DELETE_SUCCESS:
			return {
				...state,
				isDeleting: false,
				message: {
					type: 'success',
					text: '',
				},
			};

		case FILE_DELETE_REQUEST:
			return {
				...state,
				isDeletingFile: true,
				message: {
					type: '',
					text: '',
				},
			};

		case FILE_DELETE_FAILURE:
			return {
				...state,
				isDeletingFile: true,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case FILE_DELETE_SUCCESS:
			return {
				...state,
				isDeletingFile: false,
				message: {
					type: 'success',
					text: '',
				},
			};

		case FILE_UPLOAD_REQUEST:
			return {
				...state,
				isUploadingFiles: true,
				message: {
					type: '',
					text: '',
				},
			};

		case FILE_UPLOAD_FAILURE:
			return {
				...state,
				isUploadingFiles: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case FILE_UPLOAD_SUCCESS:
			return {
				...state,
				isUploadingFiles: false,
				message: {
					type: 'success',
					text: '',
				},
			};

		case FOLDER_TOKEN_CREATE_REQUEST:
			return {
				...state,
				isCreatingToken: true,
				message: {
					type: '',
					text: '',
				},
			};

		case FOLDER_TOKEN_CREATE_FAILURE:
			return {
				...state,
				isCreatingToken: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case FOLDER_TOKEN_CREATE_SUCCESS:
			return {
				...state,
				isCreatingToken: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case FOLDER_TOKEN_DELETE_REQUEST:
			return {
				...state,
				isDeletingToken: true,
				message: {
					type: '',
					text: '',
				},
			};

		case FOLDER_TOKEN_DELETE_FAILURE:
			return {
				...state,
				isDeletingToken: true,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case FOLDER_TOKEN_DELETE_SUCCESS:
			return {
				...state,
				isDeletingToken: false,
				message: {
					type: 'success',
					text: '',
				},
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/folders.js